import React from 'react'

function First() {
  return (
    <>
        <section id="faq" className="faq-area pt-120 pb-120">
            <div className="container">
                <div className="row">
                <div className="col-lg-6 col-md-6">
                    <div className="faq-wrap">
                    <div className="accordion" id="accordionExample">
                        <div className="card">
                        <div className="card-header" id="headingOne">
                            <h2 className="mb-0">
                            <button className="faq-btn collapsed"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne">
                                Breaking The Rules Using SQLite To Demo Web?
                            </button>
                            </h2>
                        </div>
                        <div id="collapseOne"
                            className="collapse"
                            aria-labelledby="headingOne"
                            data-parent="#accordionExample" style={{}} >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                        <div className="card">
                        <div className="card-header" id="headingTwo">
                            <h2 className="mb-0">
                            <button className="faq-btn" type="button"
                                data-toggle="collapse"
                                data-target="#collapseTwo"
                                aria-expanded="true" aria-controls="collapseTwo" >
                                Monthly Web Development Update Pragmatic Releasing?
                            </button>
                            </h2>
                        </div>
                        <div id="collapseTwo"
                            className="collapse show"
                            aria-labelledby="headingTwo"
                            data-parent="#accordionExample" style={{}} >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                        <div className="card">
                        <div className="card-header" id="headingThree">
                            <h2 className="mb-0">
                            <button className="faq-btn collapsed"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseThree"
                                aria-expanded="false" aria-controls="collapseThree" >
                                How To Use Underlined Text To Improve User Experience
                            </button>
                            </h2>
                        </div>
                        <div id="collapseThree"
                            className="collapse"
                            aria-labelledby="headingThree"
                            data-parent="#accordionExample" style={{}} >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                        <div className="card">
                        <div className="card-header" id="headingFour">
                            <h2 className="mb-0">
                            <button className="faq-btn collapsed" type="button"
                                data-toggle="collapse"
                                data-target="#collapseFour"
                                aria-expanded="false"
                                aria-controls="collapseFour" >
                                Understanding CSS Layout And The Block Formatting
                            </button>
                            </h2>
                        </div>
                        <div id="collapseFour"
                            className="collapse"
                            aria-labelledby="headingFour"
                            data-parent="#accordionExample" >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="faq-wrap">
                    <div className="accordion" id="accordionExample1">
                        <div className="card">
                        <div className="card-header" id="headingfive">
                            <h2 className="mb-0">
                            <button className="faq-btn collapsed"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapsefive"
                                aria-expanded="false" aria-controls="collapsefive" >
                                Breaking The Rules Using SQLite To Demo Web?
                            </button>
                            </h2>
                        </div>
                        <div id="collapsefive"
                            className="collapse"
                            aria-labelledby="headingfive"
                            data-parent="#accordionExample1"
                            style={{}} >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                        <div className="card">
                        <div className="card-header" id="headingSix">
                            <h2 className="mb-0">
                            <button className="faq-btn"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseSix"
                                aria-expanded="true"
                                aria-controls="collapseSix">
                                Monthly Web Development Update Pragmatic Releasing?
                            </button>
                            </h2>
                        </div>
                        <div id="collapseSix"
                            className="collapse show"
                            aria-labelledby="headingSix"
                            data-parent="#accordionExample"
                            style={{}} >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                        <div className="card">
                        <div className="card-header" id="headingSeveen">
                            <h2 className="mb-0">
                            <button className="faq-btn collapsed"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseSeveen"
                                aria-expanded="false"  aria-controls="collapseSeveen" >
                                How To Use Underlined Text To Improve User Experience
                            </button>
                            </h2>
                        </div>
                        <div id="collapseSeveen"
                            className="collapse"
                            aria-labelledby="headingSeveen"
                            data-parent="#accordionExample" style={{}} >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                        <div className="card">
                        <div className="card-header" id="headingEighte">
                            <h2 className="mb-0">
                            <button className="faq-btn collapsed" type="button"
                                data-toggle="collapse"
                                data-target="#collapseEighte"
                                aria-expanded="false" aria-controls="collapseEighte" >
                                Understanding CSS Layout And The Block Formatting
                            </button>
                            </h2>
                        </div>
                        <div id="collapseEighte" className="collapse"
                            aria-labelledby="headingEighte"
                            data-parent="#accordionExample" >
                            <div className="card-body">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                            do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default First